import {
  LiveStatsTopics, STATS_TYPES, AGGREGATION_LEVELS,
} from '@ahaslides-product/frontend-toolkit'

const scaleActions = {
  subscribeScaleUpdateAction: async ({ dispatch }, { slide }) => {
    const statsKeys = [
      LiveStatsTopics.averageScorePerActivityTopic(slide.id, slide.version),
      LiveStatsTopics.answerCountPerActivityTopic(slide.id, slide.version),
    ]
    const questions = slide.SlideOptions
    if (questions && questions.length > 0) {
      statsKeys.push(
        ...questions.map((question) => LiveStatsTopics.averageScorePerQuestionTopic(
          slide.id,
          slide.version,
          question.id,
        )),
      )
    }
    await dispatch('fetchStatsByKeyAction', {
      statsKeys,
    })
    await dispatch('fetchStatsByWildCardAction', {
      path: `${STATS_TYPES.ANSWER_COUNT}/${AGGREGATION_LEVELS.PER_ANSWER_VALUE}/${slide.id}/${slide.version}`,
    })
    dispatch('subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ACTIVITY,
    })
  },
}

export default scaleActions
